import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import { ActionPlansTable } from "../../../components/Admin/ActionPlans/ActionPlansTable";
import { ActionPlanForm }   from "../../../components/Admin/ActionPlans/ActionPlanForm";
import { BasicDrawer, ManagementModuleTitle } from "../../../components/Shared";
import { useLanguage } from "../../../contexts";
import { useCompany } from "../../../contexts/CompanyContext";
import "./ActionPlans.scss";

const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 5 }, (_, i) => CURRENT_YEAR - i);

export function ActionPlans() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const { company } = useCompany();

  const [reload,   setReload]   = useState(false);
  const [year,     setYear]     = useState(CURRENT_YEAR);
  const onReload = () => setReload((p) => !p);

  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const openEdit  = (item) => { setEditItem(item); setShowForm(true); };
  const closeForm = ()     => { setShowForm(false); setEditItem(null); };

  const hasCompany = company && company !== "0" && company !== 0;

  const [showYearMenu, setShowYearMenu] = useState(false);
  const yearMenuRef = useRef(null);

  useEffect(() => {
    if (!showYearMenu) return;
    const handler = (e) => {
      if (yearMenuRef.current && !yearMenuRef.current.contains(e.target))
        setShowYearMenu(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showYearMenu]);

  return (
    <div className="action-plans-page">
      <div className="action-plans-page__title-bar">
        <ManagementModuleTitle labelClassName="action-plans-page__title" />
      </div>

      <div className="action-plans-page__year-bar" ref={yearMenuRef}>
        <button
          type="button"
          className="action-plans-page__year-bar__toggle"
          onClick={() => setShowYearMenu((v) => !v)}
        >
          <span className="action-plans-page__year-bar__label">{year}</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" className={`action-plans-page__year-bar__arrow${showYearMenu ? " action-plans-page__year-bar__arrow--open" : ""}`}>
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 8v6m0 0-2.5-2.5M12 14l2.5-2.5"/>
          </svg>
        </button>

        {showYearMenu && (
          <div className="action-plans-page__year-menu">
            {YEAR_OPTIONS.map((y) => (
              <button
                type="button"
                key={y}
                className={`action-plans-page__year-menu__item${y === year ? " action-plans-page__year-menu__item--active" : ""}`}
                onClick={() => { setYear(y); setShowYearMenu(false); }}
              >
                {y}
              </button>
            ))}
          </div>
        )}
      </div>

      {hasCompany ? (
        <ActionPlansTable
          reload={reload}
          onReload={onReload}
          onEdit={openEdit}
          year={year}
        />
      ) : (
        <div className="no-site-warning">
          <Icon name="building outline" />
          <p>{t("select_company_from_header") || "Selecciona una empresa desde el encabezado"}</p>
        </div>
      )}

      <BasicDrawer show={showForm} close={closeForm} width="70vw" hideHeader flush>
        <ActionPlanForm
          show={showForm}
          close={closeForm}
          actionPlan={editItem}
          onSaved={onReload}
        />
      </BasicDrawer>
    </div>
  );
}
